<ng-container *ngIf="detail">
<div class="view-item">
    <div class="row justify-content-between">
        <h5>Propriétés générales</h5>
    </div>
    <div class="form-group row">
        <label for="raissocial" class="col-sm-2">Raison sociale : </label>
        <input type="text" class="col-sm-2 form-control" id="raissocial" name="raissocial" value="{{detail.raison_sociale}}" disabled>
    </div>
    <div class="form-group row">
        <label for="siret" class="col-sm-2">Siret : </label>
        <input type="text" class="col-sm-2 form-control" id="siret" name="siret" value="{{detail.siret}}" disabled>
    </div>
    <div class="form-group row">
        <label for="code" class="col-sm-2">Code DIVALTO : </label>
        <input type="text" id="code" name="code" class="col-sm-2 form-control" value="{{detail.code_ebp}}" disabled>
    </div>
    <p>Cette société est liée à {{detail.fournisseurs_count}} fournisseur(s) et {{detail.fabricants_count}} fabricant(s).</p>
</div>
<div class="view-item">
    <div class="row justify-content-between">
        <h5>Adresses</h5>
    </div>
    <div class="table-responsive">
    <table class="table table-sm table-striped">
        <thead>
            <th (click)="sortby('nom_adresse')" scope="col">Nom adresse</th>
            <th (click)="sortby('destinataire_adresse')" scope="col">Destinataire</th>
            <th (click)="sortby('adresse')" scope="col">Adresse</th>
            <th (click)="sortby('complement_adresse')" scope="col">Complément</th>
            <th (click)="sortby('codepostal_adresse')" scope="col">Code Postal</th>
            <th (click)="sortby('ville_adresse')" scope="col">Ville</th>
            <th (click)="sortby('pays_adresse')" scope="col">Pays</th>

        </thead>
        <tbody>
            <tr>
                <td colspan="9">Aucun élément à afficher ...</td>
            </tr>
        </tbody>
    </table>
</div>
</div>
<div class="view-item">
    <div class="row justify-content-between">
        <h5>Personnes</h5>
    </div>
    <table class="table table-sm table-striped">
        <thead>
            <th (click)="sortby('civilite_personne')">Civilité</th>
            <th (click)="sortby('nom_personne')">Nom</th>
            <th (click)="sortby('role_personne')">Rôle</th>
        </thead>
        <tbody>

            <tr *ngFor="let personne of personnes.personnes">
                <td>{{ personne.civilite }}</td>
                <td>{{personne.nom}} {{ personne.prenom }}</td>
                <td>{{ personne.nom_role }}</td>
                <td scope="col" class="material-icons">edit</td>
                <td scope="col" class="material-icons">clear</td>
            </tr>
        </tbody>
    </table>
</div>
<div class="view-item table-responsive">
    <h5>Installations</h5>
    <table class="table table-sm table-striped">
        <thead>
            <th (click)="sortby('machine_installation')">Machine</th>
            <th (click)="sortby('nom_installation')">Nom de l'installation</th>
            <th (click)="sortby('codepostal_installation')">Code postal</th>
            <th (click)="sortby('ville_installation')">Ville</th>
            <th (click)="sortby('pays_installation')">Pays</th>
        </thead>
        <tbody>
            <tr *ngFor="let installation of installations.societe_installations">
                <td>{{installation.numero_serie}}</td>
                <td>{{ installation.nom_installation }}</td>
                <td>{{ installation.code_postal }}</td>
                <td>{{ installation.ville }}</td>
                <td></td>
            </tr>
        </tbody>
    </table>
</div>
</ng-container>